/* tslint:disable */
/* eslint-disable */
/**
 * Fila12 API
 * Through this API you can access .
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomError,
    CustomErrorFromJSON,
    CustomErrorFromJSONTyped,
    CustomErrorToJSON,
    VenueDto,
    VenueDtoFromJSON,
    VenueDtoFromJSONTyped,
    VenueDtoToJSON,
} from './';

/**
 * The response with a objects of type "T".
 * @export
 * @interface VenueDtoResponseItemViewModel
 */
export interface VenueDtoResponseItemViewModel {
    /**
     * Gets the list of errors.
     * @type {Array<CustomError>}
     * @memberof VenueDtoResponseItemViewModel
     */
    readonly errors?: Array<CustomError> | null;
    /**
     * 
     * @type {VenueDto}
     * @memberof VenueDtoResponseItemViewModel
     */
    item?: VenueDto;
}

export function VenueDtoResponseItemViewModelFromJSON(json: any): VenueDtoResponseItemViewModel {
    return VenueDtoResponseItemViewModelFromJSONTyped(json, false);
}

export function VenueDtoResponseItemViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): VenueDtoResponseItemViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(CustomErrorFromJSON)),
        'item': !exists(json, 'item') ? undefined : VenueDtoFromJSON(json['item']),
    };
}

export function VenueDtoResponseItemViewModelToJSON(value?: VenueDtoResponseItemViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'item': VenueDtoToJSON(value.item),
    };
}


